import { useEffect, useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

const ITEMS = [
  {
    text: "We've worked with three agencies before Digi Savvy. None understood RERA, none understood real estate buyer psychology, none could keep CPL under ₹450. These guys did all three. Our 2-tower project sold out 5 months ahead of schedule.",
    role: "Head of Sales",
    company: "A leading NCR builder",
    avatar: "H",
  },
  {
    text: "From plotted layouts in Sonipat to a luxury floor portfolio in South Delhi — Digi Savvy delivered weekly site visits like clockwork. CPL dropped 38% in the first 60 days. Our sales team has never been busier.",
    role: "Managing Director",
    company: "A South Delhi developer",
    avatar: "M",
  },
  {
    text: "We needed to target NRIs in Dubai, Singapore and Toronto for our luxury Noida tower. Digi Savvy built a multi-country funnel that filled our pipeline with site-visit-ready buyers in 90 days. Transparent, accountable, weekly war-rooms — exactly what we needed.",
    role: "VP Marketing",
    company: "A Noida luxury developer",
    avatar: "V",
  },
  {
    text: "As a channel partner, I needed leads I could actually close — not vanity clicks. Digi Savvy's WhatsApp-first funnels send me site-visit-ready buyers within 24 hours. My conversion ratio is 3x what it used to be.",
    role: "Founder",
    company: "A Gurugram brokerage",
    avatar: "F",
  },
  {
    text: "Our managed-farms project in Kotputli was a niche play with very specific HNI buyers. Digi Savvy crafted a passive-income narrative, ran a discreet family-office outreach, and we sold 118 acres in under 6 months. Surgical.",
    role: "CEO",
    company: "A managed-farms operator",
    avatar: "C",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((v) => (v + 1) % ITEMS.length), 6500);
    return () => clearInterval(t);
  }, [paused]);

  const t = ITEMS[i];

  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 border-t border-white/5 overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="absolute -top-32 right-1/2 translate-x-1/2 w-[600px] h-[400px] rounded-full bg-[#d4ff4f]/10 blur-[140px]" />
      <div className="relative max-w-[1100px] mx-auto px-5 sm:px-8 text-center">
        <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#जुबानी</div>
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95] mb-12">
          What builders<br />
          <span className="italic text-[#d4ff4f]">actually say.</span>
        </h2>

        <div className="relative rounded-3xl border border-white/10 bg-white/[0.03] p-8 sm:p-14 min-h-[420px] flex flex-col items-center justify-center">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-[#d4ff4f]/30" />
          <Quote className="absolute bottom-6 right-6 w-12 h-12 text-[#d4ff4f]/30 rotate-180" />

          <div key={i} className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <p className="font-display text-xl sm:text-2xl md:text-3xl leading-snug tracking-tight" data-testid={`testimonial-text-${i}`}>
              "{t.text}"
            </p>
            <div className="mt-10 flex items-center justify-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d4ff4f] to-emerald-400 flex items-center justify-center font-display text-lg text-black">
                {t.avatar}
              </div>
              <div className="text-left">
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#d4ff4f]">— {t.role}</div>
                <div className="text-sm text-white/60">{t.company}</div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <button
            data-testid="testimonial-prev"
            onClick={() => setI((v) => (v - 1 + ITEMS.length) % ITEMS.length)}
            className="absolute left-3 sm:-left-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-white/15 bg-[#0a0b08]/80 hover:bg-[#d4ff4f] hover:text-black flex items-center justify-center transition"
            aria-label="Previous testimonial"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            data-testid="testimonial-next"
            onClick={() => setI((v) => (v + 1) % ITEMS.length)}
            className="absolute right-3 sm:-right-6 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full border border-white/15 bg-[#0a0b08]/80 hover:bg-[#d4ff4f] hover:text-black flex items-center justify-center transition"
            aria-label="Next testimonial"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-6" data-testid="testimonial-dots">
          {ITEMS.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              aria-label={`Go to testimonial ${idx + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                idx === i ? "w-10 bg-[#d4ff4f]" : "w-2 bg-white/20 hover:bg-white/40"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
